import { Component, Input } from '@angular/core';

export enum IconType {
  Account = "Account",
  Admin = "Admin",
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  ArrowUp = "ArrowUp",
  Call = "Call",
  Chargeback = "Chargeback",
  Chat = "Chat",
  Cognition = "Cognition",
  CreditCard = "CreditCard",
  Customer = "Customer",
  Dashboard = "Dashboard",
  Dollar = "Dollar",
  Download = "Download",
  Edit = "Edit",
  Email = "Email",
  Favorite = "Favorite",
  Favorite_unchecked = "Favorite_unchecked",
  Feedback = "Feedback",
  File = "File",
  Impersonate = "Impersonate",
  Invoice = "Invoice",
  Key = "Key",
  Location = "Location",
  MinusRemove = "MinusRemove",
  OpenInNewWindow = "OpenInNewWindow",
  PDF = "PDF",
  Phone = "Phone",
  PlusAdd = "PlusAdd",
  Profile = "Profile",
  Report = "Report",
  Search = "Search",
  Settings = "Settings",
  SignOut = "SignOut",
  StarClosed = "StarClosed",
  StarOpen = "StarOpen",
  Statement = "Statement",
  Suggestion = "Suggestion",
  Support = "Support",
  User = "User",
  Transaction = "Transaction",
  VirtualTerminal = "VirtualTerminal",
  Trash = "Trash",
  Info = "Info",
  Warning = "Warning",
  Error = "Error",
  Success = "Success",
  CalendarClock = "CalendarClock",
}

@Component({
    selector: 'app-icon',
    templateUrl: './icon.html',
    standalone: false
})
export class IconComponent {
  @Input() type:any | undefined = undefined;
  @Input() size:number | undefined = undefined;
  @Input() class:string = "";
  @Input() style:string = "";
  @Input() color:string | undefined = undefined;

  IconType = IconType;

  private _DEFAULT_SIZE = 24;
  public _class: string = "icon"
  public _width: string = "";
  public _height: string = "";

  ngOnInit() {
    if (!this.size) {
      this._width = this._DEFAULT_SIZE + "px";
      this._height = this._DEFAULT_SIZE + "px";
    }
    else if (this.size) {
      this._width = this.size + "px";
      this._height = this.size + "px";
    }
    this._class += " " + this.class;
  }
}
